import * as React from "react";
import type { SVGProps } from "react";
const SvgWalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <g
      stroke="#05B2AE"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
    >
      <path d="M6 10.5v27c0 1.65 1.35 3 3 3h30c1.65 0 3-1.35 3-3v-21c0-1.65-1.35-3-3-3H9c-1.65 0-3-1.35-3-3m0 0c0-1.65 1.35-3 3-3h7.5" />
      <path d="M42 30h-7.5c-1.65 0-3-1.35-3-3s1.35-3 3-3H42zM21.15 9.6l9.75-5.7 3.15 5.7" />
    </g>
  </svg>
);
export default SvgWalletIcon;
